var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPlayWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#FFF",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M19.0456 10.3288C20.1601 10.9723 20.1601 12.5809 19.0456 13.2244L10.8959 17.9296C9.78144 18.573 8.38833 17.7687 8.38833 16.4818L8.38833 7.07137C8.38833 5.78447 9.78144 4.98015 10.8959 5.6236L19.0456 10.3288Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlayWhite);
export default __webpack_public_path__ + "static/media/ic_play_white.985f734935bb2dc42f5e5c555b69fc60.svg";
export { ForwardRef as ReactComponent };